/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import React from "react";
import GuardEntryAndExitFormDetailsApp from "./Functionality/GuardEntryAndExitFormDetailsApp";
import GuardGeneralEntryExitDetails from "./GeneralEntryExit/GuardGeneralEntryExitDetails";
import GuardPlantMaterialControlDetails from "./PlantMaterialControl/GuardPlantMaterialControlDetails";
import GuardCratesAndPalletsReturnDetails from "./CratesAndPalletsReturn/GuardCratesAndPalletsReturnDetails";
import GuardPoultryTruckExitDetails from "./PoultryTruckExit/GuardPoultryTruckExitDetails";
import {ENTRY_AND_EXIT_FORMS} from "../../../../MaterialControl/Model/Model";
import GuardLivePoultryTruckDetails from "./LivePoultryTruck/GuardLivePoultryTruckDetails";

/**
 * Detail of an entry and exit form read by the guard at the gate.
 *
 * The form is read with the same service the requester uses, so the
 * information is loaded once and the type of the form tells which detail is
 * displayed for it. Every type falls back to the general entry and exit while
 * its own detail for the guard is registered.
 *
 * @returns {JSX.Element} Detail of the form matching its type.
 */
const GuardEntryAndExitFormDetails = () => {
    const {
        t,
        navigate,
        DEV,
        isGuard,
        permission,
        contentCardRef,
        contentTableRef,
        containerCardRef,
        containerTableRef,
        item,
        evidence,
        form,
        showBadge,
        gateLog,
        setGateLog,
        handleChange,
        photoPicker,
        setPhotoPicker,
        emptyFields,
        emptyFieldsItems,
        setEmptyFieldsItems,
        setModified,
        showConfirmModal,
        handleDispatch,
        openReportModal,
        handleActionModal,
        closeModal,
        goBack
    } = GuardEntryAndExitFormDetailsApp();

    const DetailsByForm = {
        [ENTRY_AND_EXIT_FORMS.GENERAL_ENTRY_EXIT.key]: GuardGeneralEntryExitDetails,
        [ENTRY_AND_EXIT_FORMS.PLANT_MATERIAL_CONTROL.key]: GuardPlantMaterialControlDetails,
        [ENTRY_AND_EXIT_FORMS.CRATES_AND_PALLETS_RETURN.key]: GuardCratesAndPalletsReturnDetails,
        [ENTRY_AND_EXIT_FORMS.POULTRY_TRUCK_EXIT.key]: GuardPoultryTruckExitDetails,
        [ENTRY_AND_EXIT_FORMS.LIVE_POULTRY_TRUCK.key]: GuardLivePoultryTruckDetails
    };

    const Details = DetailsByForm[form?.key];

    return (
        <Details
            t={t}
            navigate={navigate}
            DEV={DEV}
            isGuard={isGuard}
            permission={permission}
            contentCardRef={contentCardRef}
            contentTableRef={contentTableRef}
            containerCardRef={containerCardRef}
            containerTableRef={containerTableRef}
            item={item}
            evidence={evidence}
            form={form}
            showBadge={showBadge}
            gateLog={gateLog}
            setGateLog={setGateLog}
            handleChange={handleChange}
            photoPicker={photoPicker}
            setPhotoPicker={setPhotoPicker}
            emptyFields={emptyFields}
            emptyFieldsItems={emptyFieldsItems}
            setEmptyFieldsItems={setEmptyFieldsItems}
            setModified={setModified}
            showConfirmModal={showConfirmModal}
            handleDispatch={handleDispatch}
            openReportModal={openReportModal}
            handleActionModal={handleActionModal}
            closeModal={closeModal}
            goBack={goBack}
        />
    );
};

export default GuardEntryAndExitFormDetails;
